/**
 * Resource sections of a facility: /api/v2/facilities/{facilityId}/resource_categories
 */
import {
  schedulingFetchDelete,
  schedulingFetchGet,
  schedulingFetchPatch,
  schedulingFetchPost,
} from "app/utils/request/scheduling/fetch";
import { ResourceCategoryResponse, ResourceKind } from "./facilityResources";

export async function getResourceCategories(
  facilityId: string
): Promise<ResourceCategoryResponse[]> {
  const response = await schedulingFetchGet<ResourceCategoryResponse[]>(
    `facilities/${facilityId}/resource_categories`
  );

  return Array.isArray(response) ? (response as ResourceCategoryResponse[]) : [];
}

export function createResourceCategory(
  facilityId: string,
  payload: { title: string; kind: ResourceKind }
): Promise<ResourceCategoryResponse> {
  return schedulingFetchPost<ResourceCategoryResponse>(
    `facilities/${facilityId}/resource_categories`,
    payload
  );
}

export function updateResourceCategory(
  facilityId: string,
  categoryId: number,
  payload: { title: string }
): Promise<ResourceCategoryResponse> {
  return schedulingFetchPatch<ResourceCategoryResponse>(
    `facilities/${facilityId}/resource_categories/${categoryId}`,
    payload
  );
}

export async function deleteResourceCategory(
  facilityId: string,
  categoryId: number
): Promise<void> {
  await schedulingFetchDelete(
    `facilities/${facilityId}/resource_categories/${categoryId}`
  );
}
